module.exports = __webpack_public_path__ + "d05ef6584b4fa1d0288f7f31aa169a8b.fbx";